import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Globals } from "../../_models/globals";
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-zoho-auth',
  templateUrl: './zoho-auth.component.html',
  styleUrls: ['./zoho-auth.component.scss'],
})
export class ZohoAuthComponent implements OnInit {

  clientId: string = '';
  clientSecret: string = '';
  connectionName: string = '';
  accountOwnerId: string = '';
  storeOrganizationId: string = '';
  code: any = '';

  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private route: ActivatedRoute, private router: Router) {

    this.route.queryParams.subscribe((params: any) => {
      console.log("total::" + params);
      if ((params || {}).code) {
        this.code = params.code;
      }
      if ((params || {}).state) {
        console.log("state::" + params.state);

        var deData = CryptoJS.AES.decrypt(decodeURIComponent(params.state), 'secret key 123');
        var conversionDecryptOutput = JSON.parse(deData.toString(CryptoJS.enc.Utf8));


        //   var conversionDecryptOutput = CryptoJS.AES.decrypt(params.state, "secret key 123").toString(CryptoJS.enc.Utf8);
        console.log("Info::" + conversionDecryptOutput);
        let stateValues = conversionDecryptOutput.split("|");
        console.log("stateValues::" + stateValues);
        this.clientId = stateValues[0];
        this.connectionName = stateValues[1];
        this.storeOrganizationId = stateValues[2];
        this.accountOwnerId = stateValues[3];
        this.clientSecret = stateValues[4];
      }
    });
    console.log("clientId::" + this.clientId);
    console.log("this.connectionName:" + this.connectionName);
    console.log("this.storeOrganizationId:" + this.storeOrganizationId);
    console.log("this.accountOwnerId:" + this.accountOwnerId);
    console.log("this.clientSecret:" + this.clientSecret);

    this.g.loaderDisplay = "display";

    if (this.accountOwnerId) {

      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/toStoreZohoCommerceCredentials', {
        "accountOwnerId": this.accountOwnerId,
        "brandImageUrl": "string",
        "clientId": this.clientId,
        "clientSecret": this.clientSecret,
        "connectionName": this.connectionName,
        "organizationId": 1,
        "storeOrganizationId": this.storeOrganizationId,
        "storeType": "ZOHO_COMMERCE",
        "redirectUri": "https://app.shift.in/access/zohoAuth",
        "code": this.code
      }, { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Zoho', data['message']);
          if (data['storeId']) {
            /* sessionStorage.setItem('jwt', data['token']);
            this.session.set('jwt', data['token']); */
            sessionStorage.setItem('jwt', data['token']);

            this.router.navigate(['/admin/zohoCommerceManageStoreManagement', { type: 'ZOHO_COMMERCE', id: data['storeId'] }]);
          }
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    }
    else {
      this.g.loaderDisplay = "";
      this.router.navigate(['/admin/storeConnections']);
    }
  }

  ngOnInit() { }

}
